import { useAuthSelector } from 'app/data/auth';
import menuQueryKeys from 'app/hooks/queries/menu/menuQueryKeys';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { MenusPageResponse } from 'types/menu';

export const useListMenusQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of menus
  // - just get ALL menus+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = menuQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<MenusPageResponse, Error>(
    queryKey,
    () =>
      sdk.menu.query.menus(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListMenusQuery;
